import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Container, Header, Segment, Grid, Card, Message, Divider, List, Step } from 'semantic-ui-react';
import '../Playbook.css';

class IntentionalityCommunication extends Component {
    render() {
        return (
            <Container fluid className="playbook-container">
                <h1 className="ui icon center aligned header playbook-branded-header" style={{fontFamily: 'Montserrat', textTransform: 'uppercase', color: 'rgb(35, 37, 58)', fontWeight: 600, fontSize: '38px', marginBottom: '-9px'}}>
                    <i aria-hidden="true" className="icon">
                        <img src="/static/media/logo-icon.7bb8994723bbdcd674f1.png" alt="logo-icon" style={{height: '68px', marginBottom: '-15px'}} />
                    </i>
                    Sales Activity
                </h1>
                <div className="ui divider"></div>

                <Grid stackable>
                    <Grid.Row>
                        <Grid.Column width={16}>
                            <Segment className="playbook-content">
                                <Header as="h2" className="section-header">Intentionality</Header>
                                
                                <p>
                                    When you reach out to someone, or when you have a meeting with someone, you should make 
                                    sure you can answer three key questions:
                                </p>

                                <Step.Group fluid stackable="tablet">
                                    <Step>
                                        <Step.Content>
                                            <Step.Title>What am I going to say?</Step.Title>
                                        </Step.Content>
                                    </Step>
                                    
                                    <Step>
                                        <Step.Content>
                                            <Step.Title>What am I going to ask for?</Step.Title>
                                        </Step.Content>
                                    </Step>
                                    
                                    <Step>
                                        <Step.Content>
                                            <Step.Title>What is the desired next step?</Step.Title>
                                        </Step.Content>
                                    </Step>
                                </Step.Group>

                                <p>
                                    In the sections below, you will see various types of encounters, how you approach each one, 
                                    and the anticipated outcome.
                                </p>

                                <Message warning>
                                    <Message.Header>Remember these 2 rules for outbound sales:</Message.Header>
                                    <List bulleted>
                                        <List.Item><strong>Nothing gets sold at the networking event!</strong> (Get a meeting)</List.Item>
                                        <List.Item><strong>Nothing gets sold on email!</strong> (Get a meeting)</List.Item>
                                    </List>
                                    <p>
                                        That is why we obsess over the first two encounters below, and they do different jobs. The Elevator Pitch earns you the first sit-down. The Casual Encounter is that sit-down, where your differentiators separate you and earn the problem-based meeting.
                                    </p>
                                </Message>

                                <Divider />

                                <Grid stackable columns={2} style={{marginTop: '20px', marginBottom: '20px'}}>
                                    <Grid.Row style={{display: 'flex', alignItems: 'stretch'}}>
                                        <Grid.Column style={{display: 'flex', padding: '10px'}}>
                                            <Card fluid color="blue" style={{height: '100%', display: 'flex', flexDirection: 'column'}}>
                                                <Card.Content style={{flex: 1, display: 'flex', flexDirection: 'column'}}>
                                                    <Card.Header>Cold Outreach</Card.Header>
                                                    <Card.Meta>Settings: email, LinkedIn, phone, drop by</Card.Meta>
                                                    <Card.Meta><em>Practice as: Elevator Pitch</em></Card.Meta>
                                                    <Card.Description style={{flex: 1}}>
                                                        <List bulleted>
                                                            <List.Item>
                                                                <strong>What are we going to say?</strong><br/>
                                                                2-3 sentences on the story
                                                            </List.Item>
                                                            <List.Item>
                                                                <strong>What are we going to ask for?</strong><br/>
                                                                A formal setting for a meeting (All forms – online, in person, casual, formal)
                                                            </List.Item>
                                                            <List.Item>
                                                                <strong>What is the desired next step?</strong><br/>
                                                                Commitment for an online or in-person meeting
                                                            </List.Item>
                                                        </List>
                                                    </Card.Description>
                                                </Card.Content>
                                            </Card>
                                        </Grid.Column>
                                        
                                        <Grid.Column style={{display: 'flex', padding: '10px'}}>
                                            <Card fluid color="green" style={{height: '100%', display: 'flex', flexDirection: 'column'}}>
                                                <Card.Content style={{flex: 1, display: 'flex', flexDirection: 'column'}}>
                                                    <Card.Header>Casual Encounter</Card.Header>
                                                    <Card.Meta>Settings: networking event, lunch, drinks, coffee, social event</Card.Meta>
                                                    <Card.Meta><em>Practice as: Casual Encounter</em></Card.Meta>
                                                    <Card.Description style={{flex: 1}}>
                                                        <List bulleted>
                                                            <List.Item>
                                                                <strong>What are we going to say?</strong><br/>
                                                                Short version of the story
                                                            </List.Item>
                                                            <List.Item>
                                                                <strong>What are we going to ask for?</strong><br/>
                                                                A formal setting for a meeting (Online or in person)
                                                            </List.Item>
                                                            <List.Item>
                                                                <strong>What is the desired next step?</strong><br/>
                                                                Commitment for a meeting
                                                            </List.Item>
                                                        </List>
                                                    </Card.Description>
                                                </Card.Content>
                                            </Card>
                                        </Grid.Column>
                                    </Grid.Row>
                                    
                                    <Grid.Row style={{display: 'flex', alignItems: 'stretch'}}>
                                        <Grid.Column style={{display: 'flex', padding: '10px'}}>
                                            <Card fluid color="orange" style={{height: '100%', display: 'flex', flexDirection: 'column'}}>
                                                <Card.Content style={{flex: 1, display: 'flex', flexDirection: 'column'}}>
                                                    <Card.Header>Formal Meeting</Card.Header>
                                                    <Card.Meta>Settings: In an office setting - online or in person</Card.Meta>
                                                    <Card.Meta><em>Won with: your differentiators</em></Card.Meta>
                                                    <Card.Description style={{flex: 1}}>
                                                        <List bulleted>
                                                            <List.Item>
                                                                <strong>What are we going to say?</strong><br/>
                                                                The full version of the story
                                                            </List.Item>
                                                            <List.Item>
                                                                <strong>What are we going to ask for?</strong><br/>
                                                                If the prospect has a problem that we solve
                                                            </List.Item>
                                                            <List.Item>
                                                                <strong>What is the desired next step?</strong><br/>
                                                                Identification of a problem – commitment to further discuss
                                                            </List.Item>
                                                        </List>
                                                    </Card.Description>
                                                </Card.Content>
                                            </Card>
                                        </Grid.Column>
                                        
                                        <Grid.Column style={{display: 'flex', padding: '10px'}}>
                                            <Card fluid color="purple" style={{height: '100%', display: 'flex', flexDirection: 'column'}}>
                                                <Card.Content style={{flex: 1, display: 'flex', flexDirection: 'column'}}>
                                                    <Card.Header>Problem-Based Meeting</Card.Header>
                                                    <Card.Meta>In an office setting - online or in person</Card.Meta>
                                                    <Card.Meta><em>Where solutions are defined and closes begin</em></Card.Meta>
                                                    <Card.Description style={{flex: 1}}>
                                                        <List bulleted>
                                                            <List.Item>
                                                                <strong>What are we going to say?</strong><br/>
                                                                A brief version of the story for new people; a restatement of your purpose for a prospect that is not new
                                                            </List.Item>
                                                            <List.Item>
                                                                <strong>What are we going to ask for?</strong><br/>
                                                                To create a proposal
                                                            </List.Item>
                                                            <List.Item>
                                                                <strong>What is the desired next step?</strong><br/>
                                                                Commitment to accept the proposal
                                                            </List.Item>
                                                        </List>
                                                    </Card.Description>
                                                </Card.Content>
                                            </Card>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>

                            </Segment>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Container>
        );
    }
}

export default observer(IntentionalityCommunication);
